import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { FieldElementBlock } from "../../blocks/shared/components/FieldElementBlock";

interface LongAnswerBlockMeta {
  elementableId: number;
  elementId: number;
  fieldIndex: number;
  position: number;
  profileFieldId?: number | null;
}
export interface FormLongAnswerBlockProps extends ComponentPropsWithRef<"div"> {
  blockInstanceMeta?: LongAnswerBlockMeta;
  hidden?: boolean;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const FormLongAnswerBlock = forwardRef<
  HTMLDivElement,
  FormLongAnswerBlockProps
>(
  (
    {
      label = "Long answer",
      placeholder = "",
      required = false,
      hidden = false,
      blockInstanceMeta = {},
      ...rest
    },
    ref,
  ) => (
    <FieldElementBlock
      ref={ref}
      blockInstanceMeta={blockInstanceMeta}
      fieldType="long_answer"
      hidden={hidden}
      label={label}
      placeholder={placeholder}
      required={required}
      {...rest}
    />
  ),
);

FormLongAnswerBlock.displayName = "FormLongAnswerBlock";
